
import { create_thread_fail, delete_thread_fail, delete_thread_sucsess, fetch_thread_list_failed, fetch_thread_list_start_loading, fetch_thread_list_success, set_selected_total_table_count, set_Table_List_success, start_table_loading, update_selected_table_fail } from "./reducer";
import { create_new_thread, delete_Thread, fetch_selected_total_count, get_table_list_list_by_id, get_Threads } from "../../helpers/fakebackend_helper";
import { open_success_modal } from "../Success_Modal/reducer";





export const GET_TABLE_DETAILS = (filterData) => async (dispatch) => {



  try {
    let response;





    dispatch(start_table_loading())
    
       
      response = get_table_list_list_by_id({...filterData});
    
    
    var api_response = await response;







      

        dispatch(set_Table_List_success(api_response));
        if(data.Bot_ID && filterData.databaseId){

          dispatch(GET_TOTAL_SELECTED_TABLES({database_id:filterData.databaseId , bot_id:data.Bot_ID}))
        }


   
    
  } catch (error) {
    dispatch(update_selected_table_fail(error));
  }
};

export const GET_TOTAL_SELECTED_TABLES = (filterData) => async (dispatch) => {

// console.log("Updating total tables count ");


  try {
    let response;





    dispatch(start_table_loading())
    
 
      response = fetch_selected_total_count(filterData);
    
    
    var api_response = await response;







      

        dispatch(set_selected_total_table_count(api_response));

   
    
  } catch (error) {
    dispatch(update_selected_table_fail(error));
  }
};





  

